import { Grow, Stack, useTheme } from '@mui/material';
import { ToolbarButton } from '@provision/rich-text-editor';
import { ReactElement, useCallback, useState } from 'react';
import { Tooltip } from 'src/components';
import { ToolbarIcon } from './editor-menu';
import { EditorToolbarButton, EditorToolbarButtonSize } from './editor-toolbar-button';
import { StyledDynamicIcon } from './styled-dynamic-icon';

export const EditorToolbarButtons = ({
  formattingButtons,
  size = 'medium',
  iconOverrides,
  renderToggleIcon,
}: {
  formattingButtons: ToolbarButton[];
  size?: EditorToolbarButtonSize;
  iconOverrides?: Record<string, string>;
  renderToggleIcon?: (isExpanded: boolean) => ReactElement;
}) => {
  const theme = useTheme();

  const [isToolbarExpanded, setIsToolbarExpanded] = useState(false);

  const toggleToolbar = useCallback(() => {
    setIsToolbarExpanded((isOpen) => !isOpen);
  }, []);

  return (
    <>
      <EditorToolbarButton onClick={toggleToolbar} size={size}>
        <Tooltip title={isToolbarExpanded ? 'Hide formatting' : 'Show Formatting'}>
          {renderToggleIcon ? (
            renderToggleIcon(isToolbarExpanded)
          ) : (
            <StyledDynamicIcon
              name="match_case"
              sx={{
                borderBottom: `2px solid ${
                  isToolbarExpanded ? theme.palette.primary.light : theme.palette.divider
                }`,
              }}
            />
          )}
        </Tooltip>
      </EditorToolbarButton>
      {isToolbarExpanded ? (
        <Grow in={isToolbarExpanded}>
          <Stack direction="row">
            {formattingButtons?.map((button) => (
              <ToolbarIcon
                key={button.title}
                data={button}
                size={size}
                iconOverrides={iconOverrides}
              />
            ))}
          </Stack>
        </Grow>
      ) : null}
    </>
  );
};
